import styled from 'styled-components';

export const PageContainer = styled.div`
  box-sizing: border-box;
  padding: 24px;
  width: 100%;
`;

export const NameCell = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
`;

export const AvatarImg = styled.img`
  border-radius: 50%;
  flex-shrink: 0;
  height: 25px;
  object-fit: cover;
  width: 25px;
`;
